import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC6ZhNxsvYTei6ZXxudKxTHLDGwiNac3tY",
  authDomain: "premium-tour-miyako.firebaseapp.com",
  projectId: "premium-tour-miyako",
  storageBucket: "premium-tour-miyako.firebasestorage.app",
  messagingSenderId: "951503328759",
  appId: "1:951503328759:web:669215f506933883b74af2",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
